<div class="{{ containerClass }} border border-gray-300 rounded-sm flex items-stretch">
  @for (item of buttons; track item) {
    <div
      (click)="onButtonClick(item)"
      class="button-item bg-contrast {{ itemClass }}"
      [ngClass]="{
        'bg-primary text-white': selectedButtonValue === item.value && !item.disabled,
        'hover:bg-ui-hover-1 text-txt': selectedButtonValue !== item.value && !item.disabled,
        'text-txt-disabled': item.disabled
      }"
    >
      @if (itemTemplate) {
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
      } @else {
        {{ item.label }}
      }
    </div>
  }
</div>
